import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import FolderIcon from '@material-ui/icons/Folder';
import Popover, {PopoverProps} from '@material-ui/core/Popover';
import ArrowBackIcon from 'material-ui/svg-icons/navigation/arrow-back';
import {updateTemplates} from '../ViewTemplates/requests';
import {filter as fuzzyFilter} from '../../shared/helpers/filterHelper';
import {Omit, MenuItem} from '@material-ui/core';
import {withStyles, WithStyles, createStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import connectWithRouter from '../../shared/components/redux/connectWithRouter';
import SearchField from '../../shared/components/SearchField/SearchField';
import ClearIcon from '@material-ui/icons/Clear';
import {grey} from '@material-ui/core/colors';
import * as warning from 'warning';
import {EbayListing} from 'cl-api';
import Collapse from '@material-ui/core/Collapse';
import Scrollbars from '../../shared/vendor/react-custom-scrollbars/src';
import {ACTION_DISPLAY_TYPES} from '../../shared/ActionsManager/ActionsManagerConsts';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../shared/ActionsManager/ActionsTypes';
import EbayListingsActions from '../../shared/ActionsManager/EbayListingsActions/EbayListingsActions';
import {getEbayListingsIds} from '../../shared/ActionsManager/EbayListingsActions/EbayListingsActionsHelpers';
import {getFormValues, reduxForm, InjectedFormProps} from 'redux-form';
import * as classNames from 'classnames';
import withEllipsis from '@material-ui/core/utils/withEllipsis';
import * as Waypoint from 'react-waypoint';
import Typography from '@material-ui/core/Typography';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import InlineButton from '../../shared/components/InlineButton';
import routes from '../../App/routeConstants';
import Img, {IMG_SIZES} from '../../shared/components/Img/Img';
import {PaperProps} from '@material-ui/core/Paper/Paper';

const ListItemTextWithEllipsis = withEllipsis('primary')(
  withStyles(theme => ({root: {padding: theme.spacing(0, 2)}}))(ListItemText)
);
const FolderName = withEllipsis()(
  withStyles(theme => ({
    root: {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      flexShrink: 6,
      minWidth: '25%',
    },
  }))(
    React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLElement> & WithStyles<'root'>>(
      ({className, classes: {root}, ...props}, ref) => {
        return <div className={classNames(root, className)} ref={ref} {...props} />;
      }
    )
  )
);

export interface TemplateSelectPopoverProps extends Omit<PopoverProps, 'onSelect' | 'onClose'> {
  userTags: any;
  userTemplates: any;
  templateId: any;
  onSelect?: any;
  ebayListings?: EbayListing[];
  onClose: any;
}

export const styles = (theme: Theme) =>
  createStyles({
    paper: {
      width: 450,
      height: 500,
      display: 'flex' as 'flex',
      flexDirection: 'column' as 'column',
    },
    list: {
      flexGrow: 1,
    },
    listWithMarginForActions: {
      marginBottom: 36 + theme.spacing(1),
    },
    title: {
      display: 'flex' as 'flex',
      height: 64,
      alignItems: 'center' as 'center',
      backgroundColor: grey[50],
      whiteSpace: 'nowrap' as 'nowrap',
      zIndex: 1,
    },
    backButton: {
      marginRight: theme.spacing(-2),
    },
    searchField: {
      marginLeft: 'auto!important',
    },
    actions: {
      display: 'flex' as 'flex',
      alignItems: 'center' as 'center',
      padding: theme.spacing(1, 0.5), // copied from DialogActions margin
      marginTop: theme.spacing(1),
      backgroundColor: grey[50],
      justifyContent: 'flex-end' as 'flex-end',
    },
    actionsContainer: {
      position: 'absolute' as 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
    },
    menuItem: {
      height: theme.spacing(7),
    },
    folderIcon: {
      borderRadius: '50%',
      backgroundColor: theme.palette.text.hint,
      color: theme.palette.common.white,
      padding: theme.spacing(1.5),
    },
    emptyStateText: {
      display: 'flex',
      flexDirection: 'column' as 'column',
      alignItems: 'center',
      padding: theme.spacing(1),
    },
  });

interface TemplateSelectPopoverState {
  selectedTagId: number;
  filter: string;
  titleElevation: number;
}

export type TemplateSelectPopoverFormData = Pick<EbayListing, 'templateId'>;

type TemplateSelectPopoverClassKey =
  | 'backButton'
  | 'paper'
  | 'title'
  | 'searchField'
  | 'list'
  | 'actions'
  | 'menuItem'
  | 'actionsContainer'
  | 'emptyStateText'
  | 'folderIcon'
  | 'listWithMarginForActions';

class TemplateSelectPopover extends React.PureComponent<
  InjectedFormProps<TemplateSelectPopoverFormData, TemplateSelectPopoverProps> &
    TemplateSelectPopoverProps &
    WithStyles<TemplateSelectPopoverClassKey>,
  TemplateSelectPopoverState
> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    muiTheme: PropTypes.object.isRequired,
  };

  state = {
    selectedTagId: 0,
    filter: '',
    templateId: null,
    titleElevation: 1,
  };

  componentWillMount() {
    const {open, onSelect, ebayListings} = this.props;
    warning(!(onSelect && ebayListings), 'only one of onSelect and ebayListings should be provided');
    if (open) {
      updateTemplates(0);
    }
  }

  componentWillReceiveProps(nextProps) {
    warning(
      !(nextProps.onSelect && nextProps.ebayListings),
      'only one of onSelect and ebayListings should be provided'
    );
    if (!this.props.open && nextProps.open) {
      this.setState({selectedTagId: 0, filter: ''});
      updateTemplates(0);
    }
  }

  handleFilterChange = filter => {
    this.setState({filter});
  };

  handleWaypointLeave = () => {
    this.setState({titleElevation: 2});
  };

  handleWaypointEnter = () => {
    this.setState({titleElevation: 0});
  };

  render() {
    const {
      change,
      templateId,
      handleSubmit,
      onClose,
      onExited,
      onSelect,
      ebayListings,
      userTags,
      userTemplates,
      classes: {
        emptyStateText,
        folderIcon,
        menuItem,
        backButton,
        actions,
        actionsContainer,
        title,
        searchField,
        list,
        listWithMarginForActions,
        ...otherClasses
      },
      anchorEl,
      open,
    } = this.props;
    const {selectedTagId, filter, titleElevation} = this.state;
    const templates = userTemplates[selectedTagId];
    const homeFolderSelected = selectedTagId === 0;
    const filteredTemplates = fuzzyFilter(templates, filter, ['name']);
    const filteredTags = fuzzyFilter(userTags, filter);
    let emptyState;
    if (homeFolderSelected && _.isEmpty(templates) && _.isEmpty(userTags)) {
      emptyState = (
        <React.Fragment>
          <div>You Haven’t Created a Design Template Yet.</div>
          <div>
            Go to{' '}
            <InlineButton onClick={onClose} href={routes.MyAccount.ViewTemplatesBase}>
              "My Templates"
            </InlineButton>{' '}
            page and customize a theme to your needs.
          </div>
        </React.Fragment>
      );
    } else if (_.isEmpty(filteredTags) && _.isEmpty(filteredTemplates)) {
      emptyState = 'No templates matched your search';
    } else if (templates && _.isEmpty(templates) && !homeFolderSelected) {
      emptyState = 'This folder is empty';
    }
    return (
      <Popover classes={otherClasses} onClose={onClose} onExited={onExited} anchorEl={anchorEl} open={open}>
        <Paper
          component={Typography as React.ReactType<PaperProps>}
          className={title}
          elevation={titleElevation}
          {...{variant: 'h6'}}
          square
        >
          {!homeFolderSelected ? (
            <IconButton
              id="cla-btn-back"
              className={backButton}
              onClick={() => {
                change('templateId', null);
                return this.setState({selectedTagId: 0, filter: ''});
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          ) : (
            undefined
          )}
          <FolderName id="cla-current-folder-name">
            {homeFolderSelected ? 'My Templates' : userTags[selectedTagId]}
          </FolderName>
          <SearchField
            id="cla-field-search"
            className={searchField}
            hintText="Search..."
            onChange={this.handleFilterChange}
            value={filter}
            minified
          />
          <IconButton id="cla-btn-clear" onClick={onClose}>
            <ClearIcon />
          </IconButton>
        </Paper>
        <Scrollbars key="scrollbars">
          <Waypoint onEnter={this.handleWaypointEnter} onLeave={this.handleWaypointLeave} />
          <List className={classNames({[list]: true, [listWithMarginForActions]: onSelect === undefined})}>
            {emptyState ? (
              <Typography component="div" className={emptyStateText} variant="body2">
                {emptyState}
              </Typography>
            ) : (
              <React.Fragment>
                {homeFolderSelected &&
                  _.map(filteredTags, (tag, tagId: number) => {
                    return (
                      <MenuItem
                        id={`cla-folder-${tagId}`}
                        key={tagId}
                        className={menuItem}
                        onClick={() => {
                          updateTemplates(tagId);
                          this.setState({selectedTagId: tagId, filter: ''});
                          change('templateId', null);
                        }}
                      >
                        <FolderIcon className={folderIcon} />
                        <ListItemTextWithEllipsis className="cla-folder-name" primary={tag} disableTypography />
                      </MenuItem>
                    );
                  })}
                {_.map(filteredTemplates, (template: any) => {
                  const name = template.originalName || template.name;
                  return (
                    <MenuItem
                      id={`cla-template-${template.id}`}
                      selected={template.id === templateId}
                      disabled={name === 'Autosave'}
                      className={menuItem}
                      key={template.id}
                      onClick={() => {
                        if (onSelect) {
                          onSelect(template.id, {name: name, previewUrl: template.previewUrl});
                        } else {
                          change('templateId', template.id === templateId ? null : template.id);
                        }
                      }}
                    >
                      <Img
                        className="cla-thumbnail"
                        size={IMG_SIZES.Thumbnail}
                        src={[template.thumbnailUrl, '//via.placeholder.com/48x120']}
                      />
                      <ListItemTextWithEllipsis
                        className="cla-template-name"
                        primary={template.name}
                        disableTypography
                      />
                    </MenuItem>
                  );
                })}
              </React.Fragment>
            )}
          </List>
        </Scrollbars>
        {onSelect === undefined ? (
          <Collapse appear in={!!templateId} className={actionsContainer}>
            <Paper square className={actions}>
              <EbayListingsActions
                types={[EBAY_LISTINGS_ACTIONS_TYPES.APPLY_TEMPLATE]}
                displayType={ACTION_DISPLAY_TYPES.RAISED_BUTTON}
                listingsIds={getEbayListingsIds(ebayListings)}
                handleSubmit={handleSubmit}
              />
            </Paper>
          </Collapse>
        ) : (
          undefined
        )}
      </Popover>
    );
  }
}

let templateSelectPopoverInitialValues = {templateId: null};
export default connectWithRouter((state: any) => {
  return {
    userTags: state.user.tags,
    userTemplates: state.templates.userTemplates,
    templateId: (getFormValues(EBAY_LISTINGS_ACTIONS_TYPES.PICK_TEMPLATE_TO_APPLY)(state) ||
      templateSelectPopoverInitialValues)['templateId'],
  };
})(
  reduxForm<TemplateSelectPopoverFormData, TemplateSelectPopoverProps>({
    form: EBAY_LISTINGS_ACTIONS_TYPES.PICK_TEMPLATE_TO_APPLY,
    initialValues: templateSelectPopoverInitialValues,
    onSubmitSuccess: (result, dispatch, {onClose}) => {
      onClose(null);
    },
  })(withStyles(styles)(TemplateSelectPopover))
);
